<template>
    <div>
        <div class="__img-gallery-container" itemscope itemtype="http://schema.org/ImageGallery">
            <template v-for="(item,index) in screenshots">
                <figure :key="index"
                        itemprop="associatedMedia"
                        itemscope
                        itemtype="http://schema.org/ImageObject">
                    <a :href="item.src" itemprop="contentUrl" :data-size="`${item.w}x${item.h}`">
                        <img :src="item.msrc" :alt="item.alt" itemprop="thumbnail"/>
                    </a>
                    <figcaption style="display: none" itemprop="caption description">{{item.title}}</figcaption>
                </figure>
            </template>
        </div>
        <PhotoSwipeCore/>
    </div>
</template>

<script>
    import PhotoSwipeCore from "../../../../components/Gallery/PhotoSwipeCore";

    export default {
        name: "UrlEditorScreenshotGallery",
        components: {PhotoSwipeCore},
        mounted() {
            PhotoSwipeCore.methods.initPhotoSwipeFromDOM('.__img-gallery-container', {
                loop: true,
                shareEl: false
            });
        },
        data() {
            return {
                screenshots: [
                    {
                        src: require("../../../../assets/pages/features/screenshots/url-editor/big/interface OneB Url-editor_1.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/url-editor/small/interface OneB Url-editor_1 prew.jpg"),
                        alt: 'picture1',
                        title: 'Image Caption 1',
                        w: 1280,
                        h: 720
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/url-editor/big//interface OneB Url-editor_2.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/url-editor/small/interface OneB Url-editor_2 prew.jpg"),
                        alt: 'picture2',
                        title: 'Image Caption 2',
                        w: 1280,
                        h: 720
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/url-editor/big/interface OneB Url-editor_3.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/url-editor/small/interface OneB Url-editor_3 prew.jpg"),
                        alt: 'picture3',
                        title: 'Image Caption 3',
                        w: 1280,
                        h: 720
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/url-editor/big/interface OneB Url-editor_4.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/url-editor/small/interface OneB Url-editor_4 prew.jpg"),
                        alt: 'picture4',
                        title: 'Image Caption 4',
                        w: 1280,
                        h: 720
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/url-editor/big/interface OneB Url-editor_5.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/url-editor/small/interface OneB Url-editor_5 prew.jpg"),
                        alt: 'picture5',
                        title: 'Image Caption 5',
                        w: 1280,
                        h: 720
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/url-editor/big/interface OneB Url-editor_6.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/url-editor/small/interface OneB Url-editor_6 prew.jpg"),
                        alt: 'picture6',
                        title: 'Image Caption 6',
                        w: 1280,
                        h: 720
                    }
                ]
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../../theme/theme";

    .__img-gallery-container {
        display: grid;
        grid-column-gap: 0.9rem;

        img {
            width: 100%;
            transition: all .25s;
            border: 2px solid $text20;
        }

        img:hover {
            border: 2px solid $back20;
        }
    }

    @media (max-width: 40rem) {
        .__img-gallery-container {
            grid-template-columns: 1fr 1fr;
        }
    }

    @media (min-width: 40rem) and (max-width: 60rem) {
        .__img-gallery-container {
            grid-template-columns: repeat(3, minmax(9rem, 11rem));
        }
    }

    @media (min-width: 60rem) {
        .__img-gallery-container {
            grid-template-columns: repeat(6, minmax(8rem, 10rem));
        }
    }
</style>
